import { render } from "./Output.vue?vue&type=template&id=675e8c78"
const script = {}
script.render = render

export default script